import { Component } from "@angular/core";

@Component({
  selector: "app-enterprise2-content",
  templateUrl: "enterprise2-content.component.html",
})
export class Enterprise2ContentComponent {}
